import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconGym(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 52 52",
        xmlSpace: "preserve",
        enableBackground: "new 0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.Icon-gym_svg__st0{display:none}.Icon-gym_svg__st1{display:inline;opacity:0.5}.Icon-gym_svg__st2{fill:#FF00FF}.Icon-gym_svg__st3{display:inline;opacity:0.4;fill:#D8359E}.Icon-gym_svg__st4{display:inline}.Icon-gym_svg__st5{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-gym_svg__st8{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.Icon-gym_svg__st9{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st10{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st11{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st12{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.Icon-gym_svg__st13{stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-gym_svg__st14{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st15{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st16{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st17{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.Icon-gym_svg__st18{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127}.Icon-gym_svg__st19{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-gym_svg__st20{fill:none}.Icon-gym_svg__st21{stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}'), /*#__PURE__*/React.createElement("g", {
        id: "Icon-gym_svg__stroke",
        className: "Icon-gym_svg__st0"
      }, /*#__PURE__*/React.createElement("g", {
        className: "Icon-gym_svg__st4"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
        className: "Icon-gym_svg__st5",
        x1: 33,
        y1: 23,
        x2: 19,
        y2: 23
      })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
        className: "Icon-gym_svg__st5",
        x1: 33,
        y1: 29,
        x2: 19,
        y2: 29
      })), /*#__PURE__*/React.createElement("path", {
        className: "Icon-gym_svg__st5",
        d: "M18,38h-3c-0.55,0-1-0.45-1-1V15c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v22C19,37.55,18.55,38,18,38z"
      }), /*#__PURE__*/React.createElement("path", {
        className: "Icon-gym_svg__st5",
        d: "M13,34h-3c-0.55,0-1-0.45-1-1V19c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v14C14,33.55,13.55,34,13,34z"
      }), /*#__PURE__*/React.createElement("path", {
        className: "Icon-gym_svg__st5",
        d: "M9,28H6c-0.55,0-1-0.45-1-1v-2c0-0.55,0.45-1,1-1h3"
      }), /*#__PURE__*/React.createElement("path", {
        className: "Icon-gym_svg__st5",
        d: "M43,24h3c0.55,0,1,0.45,1,1v2c0,0.55-0.45,1-1,1h-3"
      }), /*#__PURE__*/React.createElement("path", {
        className: "Icon-gym_svg__st5",
        d: "M33.9999,13.9999h3c0.55,0,1,0.45,1,1v22c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-22 C32.9999,14.4499,33.4499,13.9999,33.9999,13.9999z"
      }), /*#__PURE__*/React.createElement("path", {
        className: "Icon-gym_svg__st5",
        d: "M38.9999,17.9999h3c0.55,0,1,0.45,1,1v14c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-14 C37.9999,18.4499,38.4499,17.9999,38.9999,17.9999z"
      }))), /*#__PURE__*/React.createElement("g", {
        id: "Icon-gym_svg__filled_x5F_highlighted",
        className: "Icon-gym_svg__st0"
      }, /*#__PURE__*/React.createElement("g", {
        className: "Icon-gym_svg__st1"
      }, /*#__PURE__*/React.createElement("rect", {
        x: -109.5278,
        y: -11,
        className: "Icon-gym_svg__st2",
        width: 176.4419,
        height: 74
      }))), /*#__PURE__*/React.createElement("g", {
        id: "Icon-gym_svg__filled"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M4,25v2c0,1.1025,0.8975,2,2,2v-6C4.8975,23,4,23.8975,4,25z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M20,22v-2v-5c0-1.1025-0.8975-2-2-2h-3c-1.1025,0-2,0.8975-2,2v2h-3c-1.1025,0-2,0.8975-2,2v2v2v6v2v2 c0,1.1025,0.8975,2,2,2h3v2c0,1.1025,0.8975,2,2,2h3c1.1025,0,2-0.8975,2-2v-4v-3V22z"
      }), /*#__PURE__*/React.createElement("rect", {
        x: 22,
        y: 22,
        width: 8,
        height: 8
      }), /*#__PURE__*/React.createElement("path", {
        d: "M42,17h-3v-2c0-1.1025-0.8975-2-2-2h-3c-1.1025,0-2,0.8975-2,2v5v2v8v3v4c0,1.1025,0.8975,2,2,2h3c1.1025,0,2-0.8975,2-2 v-2h3c1.1025,0,2-0.8975,2-2v-2v-2v-6v-2v-2C44,17.8975,43.1025,17,42,17z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M46,23v6c1.1025,0,2-0.8975,2-2v-2C48,23.8975,47.1025,23,46,23z"
      }))));
    }
  }));
}
export default SvgIconGym;